////////////////////////////////////////////////// METHODS










function $(_selector){
	return document.querySelector(_selector);
}
function $$(_selector) {
	return Array.from(document.querySelectorAll(_selector));
}

function bind(_selector, _eventType, _handler) {
	$$(_selector).forEach(el => el.addEventListener(_eventType, _handler));
}
function unbind(_selector, _eventType, _handler){
	$$(_selector).forEach(el => el.removeEventListener(_eventType, _handler));
}





function addClass(_target, _class){
	const els = typeof _target === 'string' ? $$(_target) : [_target];
	els.forEach(el => el.classList.add(_class));
}

function removeClass(_target, _class){
	const els = typeof _target === 'string' ? $$(_target) : [_target];
	els.forEach(el => el.classList.remove(_class));
}










//////////////////////////////////////////////////////////////////////////////////////////////////// Getter / Setter










const HOME = 'home';
const SYSTEM = 'system';

function _page(){
	return document.body.dataset.page;
}










//////////////////////////////////////////////////////////////////////////////////////////////////// Private Functions










					const hoverOver = function(){
						addClass(this, 'hover');
					}

					const hoverOut = function(){
						removeClass(this, 'hover');
					}



function initHover(){
	console.log('--- initHover');

	//

	const hoverableObject = 'a, button, input, textarea, select, label.radio, .hoverable'

	removeClass(hoverableObject, 'hover');

	unbind(hoverableObject, 'mouseover', hoverOver);
	unbind(hoverableObject, 'mouseout', hoverOut);
	unbind(hoverableObject, 'touchstart', hoverOver);
	unbind(hoverableObject, 'touchend', hoverOut);

	bind(hoverableObject, 'mouseover', hoverOver);
	bind(hoverableObject, 'mouseout', hoverOut);
	bind(hoverableObject, 'touchstart', hoverOver);
	bind(hoverableObject, 'touchend', hoverOut);
}










function initQuantity(){
	console.log('--- initQuantity');

	//

	var MIN = 1;
	var MAX = 1;

	$$('.quantity').forEach(function(_quantity){
		var minus = _quantity.querySelector('.minus')
		var plus = _quantity.querySelector('.plus')
		var num = _quantity.querySelector('.num')

		if(!minus || !plus || !num) return

		function getVal(){
			var n = parseInt(num.value, 10)
			if(isNaN(n)) return MIN
			return n
		}

		function setVal(_n){
			console.log('--- setVal : ' + _n);

			var n = _n
			if(n < MIN) n = MIN
			if(n > MAX) n = MAX
			num.value = n
			minus.disabled = n <= MIN
			plus.disabled = n >= MAX
		}

		minus.addEventListener('click', function(){
			setVal(getVal() - 1)
		})

		plus.addEventListener('click', function(){
			setVal(getVal() + 1)
		})

		num.addEventListener('input', function(){
			num.value = num.value.replace(/[^0-9]/g, '')
		})

		num.addEventListener('blur', function(){
			setVal(getVal())
		})

		setVal(getVal())
	})
}










function initToggleTarget(){
	console.log('--- initToggleTarget');

	//

	$$('input[type="radio"][data-toggle]').forEach(function(_radio){
		var name = _radio.name

		$$('input[type="radio"][name="' + name + '"]').forEach(function(_sibling){
			_sibling.addEventListener('change', function(){
				var targetId = _radio.getAttribute('data-toggle')
				var target = $('#' + targetId)
				if(!target) return
				target.hidden = !_radio.checked
			})
		})
	})
}










function initTooltips(){
	console.log('--- initTooltips');

	//

	$$('.tooltip').forEach(_tooltip => {
		const _trigger = _tooltip.querySelector('.trigger');
		const _handler = function(_e){
			_e.stopPropagation();
			const _isActive = _tooltip.classList.contains('active');
			$$('.tooltip').forEach(_t => _t.classList.remove('active'));
			if(!_isActive) _tooltip.classList.add('active');
		};
		_trigger.removeEventListener('click', _trigger._tooltipHandler);
		_trigger._tooltipHandler = _handler;
		_trigger.addEventListener('click', _handler);
	});

	document.removeEventListener('click', document._tooltipHandler);
	document._tooltipHandler = function(_e){
		if(!_e.target.closest('.tooltip')){
			$$('.tooltip').forEach(_t => _t.classList.remove('active'));
		}
	};
	document.addEventListener('click', document._tooltipHandler);
}










function initFade(){
	console.log('--- initFade')

	var STAGGER = 500;
	var THRESHOLD = 0.5;

	var fades = $$('.fade');
	if(!fades.length) return;

	function activate(_el, _delay){
		if(_el.classList.contains('is-active')) return;
		var delay = _delay || 0;
		setTimeout(function(){
			_el.classList.add('is-active');
		}, delay)
	}

	var observer = new IntersectionObserver(function(_entries, _obs){
		var visibles = _entries.filter(function(_entry){
			return _entry.isIntersecting
		}).map(function(_entry){
			return _entry.target;
		})

		if(!visibles.length) return;

		visibles.sort(function(_a, _b){
			var pos = _a.compareDocumentPosition(_b);
			return (pos & Node.DOCUMENT_POSITION_FOLLOWING) ? -1 : 1;
		})

		visibles.forEach(function(_el, _i){
			var extra = parseInt(_el.dataset.delay, 10) || 0;
			activate(_el, _i * STAGGER + extra);
			_obs.unobserve(_el);
		});
	}, {threshold: THRESHOLD})

	fades.forEach(function(_fade){
		if(_fade.hasAttribute('data-fade-force')){
			activate(_fade, parseInt(_fade.dataset.delay, 10) || 0);
			return;
		}
		observer.observe(_fade);
	});

	window.activateFade = activate;
}










function initResponsiveVideo(){
	console.log('--- initResponsiveVideo');

	//

	const mq = window.matchMedia("(max-width: 980px)");
	// webm再生可否を一度だけ判定（Safari等で不可ならmp4にフォールバック）
	const canWebm = !!document.createElement("video").canPlayType('video/webm; codecs="vp9, vp8"')
		|| !!document.createElement("video").canPlayType("video/webm");
	$$("video[data-src-pc]").forEach(v => {
		const apply = () => {
			const sp   = mq.matches;
			const webm = sp ? v.dataset.srcSpWebm : v.dataset.srcPcWebm;
			const mp4  = sp ? v.dataset.srcSp     : v.dataset.srcPc;
			const src  = (canWebm && webm) ? webm : mp4;
			const poster = sp ? v.dataset.posterSp : v.dataset.posterPc;
			if (v.getAttribute("src") !== src) {
				if (poster) v.poster = poster;
				v.src = src;
				v.load();
			}
		};
		apply();
		mq.addEventListener("change", apply);
	});
}










function layout(){
	console.log('--- layout');

	//

	const header = $('#wrapper header');
	if(header){
		document.documentElement.style.setProperty('--header-height', header.offsetHeight + 'px');
		if(_page() === HOME){
			const teaser = $('#teaser');
			if(teaser){
				document.documentElement.style.setProperty('--visible-height', window.innerHeight - header.offsetHeight + 'px');
				document.documentElement.style.setProperty('--teaser-h1-height', $('#teaser > h1').offsetHeight + 'px');
			}
		}
	}

	//

	if(window.innerWidth >= 601){
		closeMenu();
	}
}











function follow(){

	if(_page() === HOME){
		if(window.scrollY > 0){
			addClass($('#about > h2'), 'hide');
		}else{
			removeClass($('#about > h2'), 'hide');
		}
	}

	const ids = ['about', 'location', 'program', 'floor'];
	const vh = window.innerHeight;

	//

	let curIndex = -1;
	let maxVisible = 0;
	const rects = ids.map(function(_id, _i){
		const sec = document.getElementById(_id);
		if(!sec) return null;
		const r = sec.getBoundingClientRect();
		const visible = Math.min(r.bottom, vh) - Math.max(r.top, 0); // 占有量（.current用）
		if(visible > maxVisible){
			maxVisible = visible;
			curIndex = _i;
		}
		return r;
	});

	const menus = $$('.module_object.menu');
	const mRects = menus.map(function(_menu){ return _menu.getBoundingClientRect(); });

	//

	const currentId = curIndex >= 0 ? ids[curIndex] : null;

	menus.forEach(function(_menu, _i){
		const targetId = (_menu.getAttribute('href') || '').replace('#', '');
		_menu.classList.toggle('current', targetId === currentId);

		const m = mRects[_i];
		let bestId = null;
		let most = 0;
		rects.forEach(function(_r, _j){
			if(!_r) return;
			const overlap = Math.min(m.bottom, _r.bottom) - Math.max(m.top, _r.top);
			if(overlap > most){
				most = overlap;
				bestId = ids[_j];
			}
		});
		_menu.classList.toggle('black', bestId !== 'about');
	});
}



let sideLastY = window.scrollY;

function syncSide(){
	if(window.innerWidth < 981) return;
	const side = document.getElementById('side');
	const target = document.getElementById('reservation_set');
	if(!side || !target || target.hasAttribute('data-disable-scroll-sync')){
		sideLastY = window.scrollY;
		return;
	}

	const diff = window.scrollY - sideLastY;
	sideLastY = window.scrollY;

	const maxScroll = target.scrollHeight - target.clientHeight;
	if(maxScroll <= 0) return;

	// footerに押し上げられてsticky解除中は最下部で固定
	const stickyTop = parseFloat(getComputedStyle(side).top) || 0;
	if(side.getBoundingClientRect().top < stickyTop){
		target.scrollTop = maxScroll;
		return;
	}

	target.scrollTop = Math.min(Math.max(target.scrollTop + diff, 0), maxScroll);
}










//////////////////////////////////////////////////////////////////////////////////////////////////// Public Functions










function openModal(_id, _trigger){
	console.log('--- openModal : ' + _id);

	//

	if(_trigger && _trigger.classList.contains('disabled')) return;

	//

	var _c = $('#modal > .dialog > .container');
	_c.innerHTML = $('#' + _id).innerHTML;
	// data-src の iframe（YouTube等）はモーダルを開いた時だけ読み込む＝裏での自動再生を防止
	_c.querySelectorAll('iframe[data-src]').forEach(function(f){ f.src = f.getAttribute('data-src'); });
	$('#modal > .dialog').scrollTop = 0;

	$('#modal').dataset.content = _id;
	removeClass('#modal', 'hidden');
	addClass('body', 'no_scroll');

	initHover();
	initTooltips();
}



					function closeModal(){
						addClass('#modal', 'hidden');
						removeClass('body', 'no_scroll');
						$('#modal > .dialog > .container').innerHTML = '';
					}










function removeNonAscii(_el){
	_el.value = _el.value.replace(/[^\x00-\x7F]/g, '');
}



function sanitizePassword(_el){
	_el.value = _el.value.replace(/[^\x20-\x7E]/g, '');
}





function resetSuggestionsScroll(_input){
	const _suggestions = _input.closest('.dialog').querySelector('ul.suggestions');
	if(_suggestions) _suggestions.scrollTop = 0;
}










function toggleMenu(){
	console.log('--- toggleMenu');
	console.trace('close called');

	//

	const header = document.querySelector('header');
	if(!header) return;
	const isClosed = header.classList.toggle('closed');
	document.body.classList.toggle('no_scroll', !isClosed);
	return isClosed;
}



					function closeMenu(){
						const header = document.querySelector('header');
						if(!header) return;
						header.classList.add('closed');
						document.body.classList.remove('no_scroll');
					}










function openCowlendar(){
	console.log('--- openCowlendar');

	//

	addClass($('.cowlendar-bg'), 'ariafina-cowlendar-requested');
}










//////////////////////////////////////////////////
// form validation
//////////////////////////////////////////////////

function isEmail(_v){
	return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(_v);
}
function isUrl(_v){
	return /^https?:\/\/[^\s]+$/.test(_v);
}

// エラーメッセージ用のラベル文言を取得
function getLabel(_c){
	if(/_(from|to)_(year|month)$/.test(_c.name)) return '使用期間'; // 特殊：使用期間セレクト群
	let el = _c.id ? document.querySelector('label[for="' + _c.id + '"]') : null;
	if(!el){
		const unit = _c.closest('.field, ul.field');
		if(unit) el = unit.querySelector(':scope > label') || unit.querySelector('label');
	}
	if(el){
		const span = el.querySelector('.label > span, .font > span'); // ← 素のspanを外す
		if(span && span.textContent.trim()) return span.textContent.trim();
	}
	const group = _c.closest('.fields'); // tel2/tel3 等：同グループ先頭ラベルを流用
	if(group){
		const span = group.querySelector('label .font span, label .label span');
		if(span && span.textContent.trim()) return span.textContent.trim();
	}
	if(_c.placeholder) return _c.placeholder;
	return _c.name || '項目';
}

// required 判定（属性のみ・＊マーカーは見ない）＋条件付き解除
function isRequired(_c){
	if(/_to_(year|month)$/.test(_c.name)){ // 現在使用中なら終了年月は不要
		const using = _c.form && _c.form.querySelector('input[name="using"]');
		if(using && using.checked) return false;
	}
	return _c.hasAttribute('required');
}

// 形式チェック（true = 正常）
function checkFormat(_c, _v){
	if(_c.type === 'email') return isEmail(_v);
	if(/contact/.test(_c.name)) return isUrl(_v) || isEmail(_v);
	if(_c.type === 'url') return isUrl(_v);
	if(/zip/.test(_c.name)) return /^\d{3}-?\d{4}$/.test(_v);
	if(_c.type === 'tel') return /^[0-9\-]+$/.test(_v);
	if(_c.type === 'password'){
		if(!isNewPassword(_c)) return true; // ログイン：未入力のみ（形式は見ない）
		const min = _c.minLength > 0 ? _c.minLength : 5;
		return _v.length >= min && isPassword(_v);
	}
	return true;
}
function formatMsg(_c, _label, _v){
	if(_c.type === 'password'){
		const min = _c.minLength > 0 ? _c.minLength : 5;
		if(_v.length < min) return min + '文字以上で入力してください';
		return '半角英数字・記号で入力してください';
	}
	return '正しい' + _label + 'を入力してください';
}

// collectErrors（テキスト分岐で「電話/問い合わせ先」は個別必須をスキップ）
function collectErrors(_form){
	const errors = [];
	const seenRadio = {};

	_form.querySelectorAll('input, select, textarea').forEach(function(_c){
		if(_c.type === 'hidden' || _c.disabled) return;

		const label = getLabel(_c);
		const required = isRequired(_c);
		const eitherOr = /(_tel[123]$|_contact$)/.test(_c.name); // 片方必須グループ

		if(_c.type === 'radio'){
			if(seenRadio[_c.name]) return;
			seenRadio[_c.name] = true;
			if(required && !_form.querySelector('input[name="' + _c.name + '"]:checked')){
				errors.push({control: _c, msg: label + 'を選択してください'});
			}
			return;
		}
		if(_c.type === 'checkbox'){
			if(required && !_c.checked){
				const msg = /同意/.test(label) ? 'プライバシーポリシーに同意してください' : label + 'に同意してください';
				errors.push({control: _c, msg: msg});
			}
			return;
		}
		if(_c.tagName === 'SELECT'){
			if(required && !_c.value){
				errors.push({control: _c, msg: label + 'を選択してください'});
			}
			return;
		}
		const v = _c.value.trim();
		if(required && !v){
			if(!eitherOr) errors.push({control: _c, msg: label + 'を入力してください'}); // 片方必須は個別必須にしない
			return;
		}
		if(v && !checkFormat(_c, v)){
			errors.push({control: _c, msg: formatMsg(_c, label, v)}); // ← v追加
		}
	});

	applyCustomRules(_form, errors);
	return errors;
}

// 特殊ルール：使用期間の前後関係 ＋ 電話 or 問い合わせ先（片方必須）
function applyCustomRules(_form, _errors){
	// 使用期間：終了 >= 開始（現在使用中でなければ）
	const fromY = _form.querySelector('[name$="_from_year"]');
	const toY = _form.querySelector('[name$="_to_year"]');
	const using = _form.querySelector('input[name="using"]');
	if(fromY && toY && (!using || !using.checked)){
		const fromM = _form.querySelector('[name$="_from_month"]');
		const toM = _form.querySelector('[name$="_to_month"]');
		if(fromY.value && toY.value && fromM.value && toM.value){
			const from = Number(fromY.value) * 100 + Number(fromM.value);
			const to = Number(toY.value) * 100 + Number(toM.value);
			if(to < from){
				const msg = '現在使用中にチェックするか、正しい使用終了年月を選択してください';
				_errors.push({control: toY, msg: msg}); // 終了・年
				_errors.push({control: toM, msg: msg}); // 終了・月
			}
		}
	}

	// 電話番号 or お問い合わせ先（どちらか片方必須）
	const tel1 = _form.querySelector('[name$="_tel1"]');
	const contact = _form.querySelector('[name$="_contact"]');
	if(tel1 && contact){ // 両方を持つフォーム（ショールーム）のみ
		const tels = ['1', '2', '3'].map(function(_n){ return _form.querySelector('[name$="_tel' + _n + '"]'); }).filter(Boolean);
		const phoneAny = tels.some(function(_t){ return _t.value.trim() !== ''; });
		const phoneAll = tels.every(function(_t){ return _t.value.trim() !== ''; });
		const contactFilled = contact.value.trim() !== '';

		if(!phoneAny && !contactFilled){
			// 両方空 → 電話3つ＋問い合わせ先を全部赤（メッセージは1つ）
			const msg = '電話番号かお問い合わせ先URL / メールアドレスのいずれかを入力してください';
			tels.forEach(function(_t){ _errors.push({control: _t, msg: msg}); });
			_errors.push({control: contact, msg: msg});
		}else if(phoneAny && !phoneAll){
			// 電話を書き始めたのに未完 → 空のマスだけ赤
			tels.forEach(function(_t){
				if(_t.value.trim() === '') _errors.push({control: _t, msg: '電話番号を正しく入力してください'});
			});
		}
	}

	// パスワード確認（一致）
	const pw1 = _form.querySelector('[name$="password_1"]');
	const pw2 = _form.querySelector('[name$="password_2"]');
	if(pw1 && pw2 && pw1.value && pw2.value && pw1.value !== pw2.value){
		_errors.push({control: pw2, msg: 'パスワードが一致しません'});
	}
}

// .module_object.error > .container > ul.ul へ反映（過不足なく／0件はli無し）
function renderErrors(_form, _errors){
	_form.querySelectorAll('.field.error, ul.field.error').forEach(function(_f){ _f.classList.remove('error'); });

	const ul = _form.querySelector('.module_object.error ul.ul');
	if(ul) ul.innerHTML = '';

	const seenMsg = {};
	_errors.forEach(function(_e){
		const field = _e.control.closest('.field, ul.field');
		if(field) field.classList.add('error');
		if(seenMsg[_e.msg]) return; // 同一文言（tel1/2/3等）は1つに
		seenMsg[_e.msg] = true;
		if(!ul) return;
		const li = document.createElement('li');
		li.innerHTML = '<div class="font s_12 w_r"><span></span></div>';
		li.querySelector('span').textContent = _e.msg; // textContentで安全に
		ul.appendChild(li);
	});

	const block = _form.querySelector('.module_object.error');
	if(block) block.classList.toggle('show', _errors.length > 0);
}

// POST前に呼ぶ：true=OK / false=エラーあり
function validateForm(_form){
	if(!_form) return true;
	const errors = collectErrors(_form);
	renderErrors(_form, errors);
	_form.dataset.validated = '1'; // 以降ライブ追従
	return errors.length === 0;
}

// ① blur：触れた欄だけ検証して、その .field を error 化
function blurValidate(_e){
	const c = _e.target;
	if(!c.matches || !c.matches('form .field input, form .field select, form .field textarea')) return;
	c.dataset.touched = '1';
	const field = c.closest('.field, ul.field');
	if(field) field.classList.toggle('error', !!checkControl(c));
}

// 単一コントロールの検証 → エラー文言 or ''（blur用・クロスフィールドは対象外）
function checkControl(_c){
	if(_c.type === 'hidden' || _c.disabled) return '';
	if(_c.type === 'radio' || _c.type === 'checkbox') return ''; // グループ系はsubmitで判定
	const label = getLabel(_c);
	const required = isRequired(_c);
	const eitherOr = /(_tel[123]$|_contact$)/.test(_c.name);
	if(_c.tagName === 'SELECT'){
		return (required && !_c.value) ? label + 'を選択してください' : '';
	}
	const v = _c.value.trim();
	if(required && !v) return eitherOr ? '' : label + 'を入力してください';
	if(v && !checkFormat(_c, v)) return formatMsg(_c, label, v); // ← v追加
	return '';
}

// 初期化：既存プレースホルダを消し、初回検証後は入力/変更でライブ更新
function initValidation(){
	console.log('--- initValidation');

	//

	document.querySelectorAll('form .module_object.error ul.ul').forEach(function(_ul){ _ul.innerHTML = ''; });
	document.addEventListener('blur', blurValidate, true);
	document.addEventListener('input', liveValidate);
	document.addEventListener('change', liveValidate);

	// .next ボタンのゲート：初期化＋チェック変更でライブ同期
	document.querySelectorAll('form').forEach(syncNextGate);
	document.addEventListener('change', function(_e){
		if(_e.target && _e.target.type === 'checkbox'){
			syncNextGate(_e.target.closest('form'));
		}
	});
}
function liveValidate(_e){
	const c = _e.target;
	if(!c.matches || !c.matches('form .field input, form .field select, form .field textarea')) return;

	// ① エラー中の欄は入力/変更のたびに即再判定（save前でも赤を消す）
	const field = c.closest('.field, ul.field');
	if(field && field.classList.contains('error')){
		field.classList.toggle('error', !!checkControl(c));
	}

	// ② 一度save押下したフォームは、サマリーリストもライブ追従
	const form = c.closest('form');
	if(form && form.dataset.validated){
		renderErrors(form, collectErrors(form));
	}
}

// 許容文字：半角英数字 ＋ 記号 ＋ 半角スペース
// 記号 = ! " # $ % & ' ( ) * + , - . / : ; < = > ? @ [ \ ] ^ _ ` { | } ~
function isPassword(_v){
	return /^[A-Za-z0-9\x20!"#$%&'()*+,.\/:;<=>?@[\\\]^_`{|}~-]+$/.test(_v);
}
// 設定用パスワード欄か（minlength付き＝登録・再設定）。ログイン欄は対象外
function isNewPassword(_c){
	return _c.type === 'password' && _c.hasAttribute('minlength');
}





					function saveAddress(_btn){
						const form = _btn.closest('form');
						if(!validateForm(form)) return;

						// ここからPOST処理

					}

					function saveProfile(_btn){
						const form = _btn.closest('form');
						if(!validateForm(form)) return;

						// ここからPOST処理

					}

					function register(_btn){
						const form = _btn.closest('form');
						if(!validateForm(form)) return;

						// ここからPOST処理

					}

					function submitLogin(_btn){
						const form = _btn.closest('form');
						if(!validateForm(form)) return;

						// ここからPOST処理

					}

					function send(_btn){
						const form = _btn.closest('form');
						if(!validateForm(form)) return;

						// ここからPOST処理

					}

					function addProduct(_btn){
						const form = _btn.closest('form');
						if(!validateForm(form)) return;

						// ここからPOST処理

					}

					function saveShowroomInfo(_btn){
						const form = _btn.closest('form');
						if(!validateForm(form)) return;

						// ここからPOST処理

					}

					function reset(_btn){
						const form = _btn.closest('form');
						if(!validateForm(form)) return;

						// ここからPOST処理

					}





//////////////////////////////////////////////////
// .next ボタンのチェックゲート（汎用）
//////////////////////////////////////////////////

// フォーム内の全チェックボックスがONなら .next を活性化（1つでも未チェックなら .disabled）
function syncNextGate(_form){
	if(!_form) return;
	const btn = _form.querySelector('.button.next');
	if(!btn) return;
	const boxes = _form.querySelectorAll('input[type="checkbox"]');
	if(!boxes.length) return;
	const allChecked = Array.prototype.every.call(boxes, function(_b){ return _b.checked; });
	btn.classList.toggle('disabled', !allChecked);
}

// 指定チェックボックスのフォームの .next が押せる状態か（.disabled が付いていたら false）
function nextGateOpen(_checkboxName){
	const chk = document.querySelector('input[name="' + _checkboxName + '"]');
	const form = chk && chk.closest('form');
	const btn = form && form.querySelector('.button.next');
	return !!btn && !btn.classList.contains('disabled');
}



// 「ショールーム情報を設定する」
function goShowroomInfo(){
	if(!nextGateOpen('is_administrator')) return;
	openModal('add_showroom_info_4');
}

// 「ショールーム情報を削除する」
function removeShowroomInfo(){
	if(!nextGateOpen('remove_showroom_info_notice_confirmed')) return;
	// ここから削除POST処理
}










//////////////////////////////////////////////////////////////////////////////////////////////////// Events










document.addEventListener('change', function(_e){

	if(_e.target.matches('input[name="is_administrator"]')){
		const _button = _e.target.closest('form').querySelector('a.button.next');
		if(_button) _button.classList.toggle('disabled', !_e.target.checked);
	}

	if(_e.target.matches('input[name="remove_showroom_info_notice_confirmed"]')){
		const _button = _e.target.closest('form').querySelector('a.button.next');
		if(_button) _button.classList.toggle('disabled', !_e.target.checked);
	}

	if(_e.target.matches('input[name="using"]')){
		const _target = _e.target.closest('form').querySelector('.fields.using_to');
		if(_target) _target.classList.toggle('hide', _e.target.checked);
	}
});










window.addEventListener('resize', function(){
	layout();
	follow();
});



window.addEventListener('orientationchange', function(){
	layout();
	follow();
});



let ticking = false;

window.addEventListener('scroll', function(){
	if (!ticking) {
		requestAnimationFrame(function(){
			follow();
			syncSide();
			ticking = false;
		});
		ticking = true;
	}
}, {passive: true});



window.addEventListener('focus', function(){
	layout();
	follow();
});




document.addEventListener('DOMContentLoaded', function(){
	console.log('----- DOMContentLoaded');

	//

	switch(_page()){
		case HOME:
			initFade();
			initResponsiveVideo();
			break;

		case SYSTEM:
			initFade();
			break;
	}

	initHover();
	initQuantity();
	initToggleTarget();
	initTooltips();

	initValidation();

	layout();
	follow();
});
